import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=8c91e040&scoped=true"
import script from "./Inspections.vue?vue&type=script&lang=js"
export * from "./Inspections.vue?vue&type=script&lang=js"
import style0 from "./Inspections.vue?vue&type=style&index=0&id=8c91e040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c91e040",
  null
  
)

export default component.exports